import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_FacilitySetup } from "../shared/data.service";
import { FacilityRequestModel } from "../shared/FacilityRequestModel";
import { LocationModel } from "../shared/LocationModel";

@Component({
	selector: "app-district-add-facility",
	templateUrl: "./district-add-facility.component.html",
	styleUrls: ["./district-add-facility.component.css"],
})
export class DistrictAddFacilityComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private facilityService: DataService_FacilitySetup,
		private confirmationService: ConfirmationService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////

	Saving: any = false;

	user: any;

	CurrentScreen: any = 0;

	MenuSelect = "Name";
	lstMenuItems = ["Name", "Locations", "Schools", "ScanStation", "Visitor Pass", "MS Visitor Pass"];

	////////////////////////
	//Data from all pages:
	////////////////////////

	//Page 1
	FacilityName: any = "";
	FacilityCode: any = "";
	Phone: any = "";
	Address: any = "";
	City: any = "";
	State: any = "";
	Zip: any = "";

	//Page 2
	lstLocations: any = [];

	//Page 3
	lstSchool: any = [];

	//Page 4
	ScanStationData: any;

	//Page 5
	EnableOffenderSearch: any;
	VerificationPassID: any;

	//Page 6
	MSEnableOffenderSearch: any;
	MSDefaultPassID: any;
	MSOffenderHitPassID: any;
	MSVerificationPassID: any;

	////////////////////////

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////

	onNavClick(val) {
		this.MenuSelect = this.lstMenuItems[val];
		this.CurrentScreen = val;

		//Clear future pages

		//Clear 2nd page
		if (val < 1) {
			this.lstLocations = [];
		}
		if (val < 2) {
			this.lstSchool = [];
		}
		if (val < 3) {
			this.ScanStationData = undefined;
		}
	}

	onNextClick(val) {
		//Update main data
		var d = val.Data;

		if (d != undefined) {
			//1st Page:
			if (d.FacilityName != undefined) {
				this.FacilityName = d.FacilityName;
			}
			if (d.FacilityCode != undefined) {
				this.FacilityCode = d.FacilityCode;
			}
			if (d.Phone != undefined) {
				this.Phone = d.Phone;
			}
			if (d.Address != undefined) {
				this.Address = d.Address;
			}
			if (d.City != undefined) {
				this.City = d.City;
			}
			if (d.State != undefined) {
				this.State = d.State;
			}
			if (d.Zip != undefined) {
				this.Zip = d.Zip;
			}

			//2nd Page:
			if (d.lstLocations != undefined) {
				this.lstLocations = d.lstLocations;
			}

			//3rd Page:
			if (d.lstSchool != undefined) {
				this.lstSchool = d.lstSchool;
			}

			//4th Page
			if (d.EnableMealAccounting != undefined) {
				this.ScanStationData = d;
			}

			//5th Page
			if (d.EnableOffenderSearch != undefined) {
				this.EnableOffenderSearch = d.EnableOffenderSearch;
			}
			if (d.VerificationPassID != undefined) {
				this.VerificationPassID = d.VerificationPassID;
			}
		}

		this.onNavClick(val.NextPage);
		this.CurrentScreen = val.NextPage;
	}

	onFinished(val) {
		this.Saving = true;

		//Get data from MS Visitor Pass (last page)
		this.MSDefaultPassID = val.DefaultPassID;
		this.MSOffenderHitPassID = val.OffenderHitPassID;
		this.MSVerificationPassID = val.VerificationPassID;

		var FormattedLocations: LocationModel[] = [];
		for (var i = 0; i < this.lstLocations.length; i++) {
			var next = this.lstLocations[i];

			let loc: LocationModel = {
				FacilityLocationID: -1, //Doesn't exist yet
				Active: next.ActiveDesc == "Active" ? 1 : 0,
				FacilityLocationCD: next.FacilityLocationCD,
				FacilityLocationName: next.FacilityLocationName,
			};

			FormattedLocations = [...FormattedLocations, loc];
		}

		var FormattedSchools: number[] = [];
		for (var i = 0; i < this.lstSchool.length; i++) {
			var next = this.lstSchool[i];

			FormattedSchools = [...FormattedSchools, Number(next.SchoolID)];
		}

		var DefinedBy: number = this.user.UserLevelID == 1 ? 4 : 3; //

		//Create request model to create the facility
		let parms: FacilityRequestModel = {
			FacilityID: -1,
			FacilityName: this.FacilityName,
			FacilityCode: this.FacilityCode,
			Phone: this.Phone,
			Address: this.Address,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			DefinedByID: DefinedBy,
			lstLocations: FormattedLocations,
			lstSchoolIDs: FormattedSchools,
			EnableMealAccounting: this.ScanStationData.EnableMealAccounting == true ? 1 : 0,
			EnablePersonalItem: this.ScanStationData.EnablePersonalItem == true ? 1 : 0,
			AwayBarcode: this.ScanStationData.AwayBarcode == true ? 1 : 0,
			AwayPhoto: this.ScanStationData.AwayPhoto == true ? 1 : 0,
			EnableOffenderSearch: this.EnableOffenderSearch == true ? 1 : 0,
			VerificationPassID: this.VerificationPassID,
			MSDefaultPassID: this.MSDefaultPassID,
			MSOffenderHitPassID: this.MSOffenderHitPassID,
			MSVerificationPassID: this.MSVerificationPassID,
		};

		var result = this.facilityService.FacilityInsert(parms);
		result.subscribe(
			(response) => {
				this.Saving = false;

				if (response) {
					//Success
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Facility was created successfully",
						header: "Facility Maintenance",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Error
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the facility",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Saving = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Helpers
	////////////////////////////////////////

	DisableButton(btn) {
		return btn > this.CurrentScreen || this.Saving == true;
	}

	////////////////////////////////////////
}
